import { firebase } from './api/firebase'

let db = firebase.firestore()
db.settings({timestampsInSnapshots: true})

export const prices = {
  state: {
    stylesWithPrices: {}
  },
  mutations: {
    stylesWithPrices: (state, payload) => {
      state.stylesWithPrices = payload
    }
  },
  actions: {
    setStyles: (context) => {
      db.collection('styles')
        .onSnapshot(qSnap => {
          let styles = {}
          qSnap.forEach(doc => {
            let data = doc.data()

            if (doc.id !== 'Outfit') {
              styles[doc.id] = data
            }
          })
          context.commit('stylesWithPrices', styles)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/prices.js